/* eslint-disable  */
import envConfigMapping from '@/config/api';
import baseConfig from '@/config/baseConfig';
import { nativeBridge } from '@nio-wad/universal-bridge-h5/dist/nativeBridge';
import { nioJsBridge } from '@nio-wad/universal-bridge-h5';
import { universalStorage } from '@nio-wad/universal-bridge-h5'
import moment from 'moment';
import {currentBrand, isAlps, isFyCN, isNio} from "@/utils/brandUtils";
import {ONLINE_URL} from "@/config/constant";

const { location } = window;

export default {
  getEnv() {
    let url = location.href;
    let code;
    if (
      baseConfig.localConfiguration.envCode !== null &&
      baseConfig.localConfiguration.enableLocalMode
    ) {
      return baseConfig.localConfiguration.envCode;
    }
    //0 qa 1 test 2 stg 3 prod
    let appInfo;
    try {
      appInfo = nativeBridge.getAppInfo();
    } catch (e) {
      code = 3;
    }
    if (appInfo) {
      if (appInfo.data.env === 'qa') {
        code = 0;
      } else if (appInfo.data.env === 'sit' || appInfo.data.env === 'test') {
        code = 1;
      } else if (appInfo.data.env === 'stg') {
        code = 2;
      } else {
        code = 3;
      }
    } else {
      code = 3;
    }

    console.log("getEnv",code)

    return code;
  },

  /**
   * @params 对应的配置文件的名称 , common 默认配置
   * */
  getApiEnvInfo(name) {

    console.log('getApiEnvInfo ==>', name);

    let env;
    let length = 0;
    if (!name) {
      for (let i in envConfigMapping) {
        env = envConfigMapping[i];
      }
    } else {
      for (let i in envConfigMapping) {
        envConfigMapping.length = length++;
        if (i === name) {
          env = envConfigMapping[i];
        }
      }
    }

    if (envConfigMapping.length === 0 && env === undefined) {
      for (let i in envConfigMapping) {
        env = envConfigMapping[i];
      }
    }
    if (env === undefined) {
      const error = new Error(`envConfig:${name} 没有 匹配的配置文件`);
      throw error;
      // return ;
    }
    let code = this.getEnv();

    console.log('env code==>', code);
    // 默认生产环境
    switch (code) {
      case 0:
        return env.dev;
      case 1:
        return env.test;
      case 2:
        return env.stg;
      case 3:
        return env.prod;
      default:
        return env.prod;
    }
  },
  /**
   * @params 对应的基础环境配置文件的名称
   * */
  getEnvHost(name) {
    let code = this.getEnv();
    switch (code) {
      case 0:
        return ONLINE_URL[currentBrand()]?.dev;
      case 1:
        return ONLINE_URL[currentBrand()]?.test;
      case 2:
        return ONLINE_URL[currentBrand()]?.stg;
      case 3:
        return ONLINE_URL[currentBrand()]?.prod;
      default:
        return ONLINE_URL[currentBrand()]?.prod;
    }
  },
  getEnvStr() {
    switch (this.getEnv()) {
      case 0:
        return 'dev';
      case 1:
        return 'test';
      case 2:
        return 'stg';
      case 3:
        return 'prod';
      default:
        return 'dev';
    }
  },
  basePath() {
    let pathName = baseConfig.compatible.isSupportHybrid
      ? baseConfig.compatible.prefix + process.env.VUE_APP_OFFLINE_MODULE_CODE
      : '';
    console.log('pathName', pathName);
    return pathName;
  },

  evil(fn) {
    let Fn = Function; //一个变量指向Function，防止有些前端编译工具报错

    return new Fn(`return ${fn}`)();
  },
  // 获取国际化金额展示
  getIntlMoney(value) {
    let region; // 所在地
    let currency = 'NOK'; // 币种
    if (this.isInWebview()) {
      region = nativeBridge.getAppInfo().data.region;
    }

    let p = {
      currency_code: currency,
      price: value,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };

    let result = nativeBridge.getCurrencyFormat({ data: p }).data;
    console.log(result);
    return result.display_price;
    //return new Intl.NumberFormat(region,{ style: 'currency', currency: currency,currencyDisplay:'symbol' }).format(value);
  },

  getPointDisplay(value) {
    let region;
    if (this.isInWebview()) {
      region = nativeBridge.getAppInfo().data.region;
    }

    let p = {
      number: value,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      local: region,
    };
    let result = nativeBridge.getNumberFormat({ data: p }).data;
    return result.number_display;
  },

  dateFtt(fmt, date) {
    //author: meizz
    if (typeof date === 'number') {
      date = new Date(date);
    }
    var o = {
      'M+': date.getMonth() + 1, //月份
      'd+': date.getDate(), //日
      'h+': date.getHours(), //小时
      'm+': date.getMinutes(), //分
      's+': date.getSeconds(), //秒
      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp('(' + k + ')').test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        );
    return fmt;
  },
  //
  isInWebview() {
    return navigator.userAgent.indexOf('_dsbridge') > -1;
  },
  isIphone() {
    let osinfo = nativeBridge.getOSInfo();
    let appIsIos = osinfo && osinfo['systemName'] === 'iOS' ? true : false;
    let isIOS = this.isIosUserAgent();
    return appIsIos || isIOS || false;
  },
  isIosUserAgent() {
    return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
  },

  async getBottomSafeArea() {
    const lgInfo = await nioJsBridge.getOSInfo();
    console.log('getBottomSafeArea', lgInfo);
    if (lgInfo && lgInfo.data) {
      let osInfo = lgInfo.data;
      let statusBarHeight = null;
      let bottomBarHeight = null;
      let systemName = osInfo.systemName;
      const isAndroid = (systemName && systemName.toLowerCase() == 'android');
      //获取statusBarHeight
      if (osInfo.safeAreaInsets) {
        const statusBarPixels = +osInfo.safeAreaInsets.top;
        const bottomBarPixels = +osInfo.safeAreaInsets.bottom;
        statusBarHeight = isAndroid
          ? Math.ceil(statusBarPixels / window.devicePixelRatio)
          : statusBarPixels;
        bottomBarHeight = isAndroid
          ? Math.ceil(bottomBarPixels / window.devicePixelRatio)
          : bottomBarPixels;
      }
      if (statusBarHeight && !osInfo['status_bar_height']) {
        osInfo['status_bar_height'] = statusBarHeight;
      }
      if (bottomBarHeight && !osInfo['bottom_bar_height']) {
        osInfo['bottom_bar_height'] = bottomBarHeight;
      }
      if (!osInfo['device_type'] && systemName) {
        osInfo['device_type'] = systemName.toLowerCase();
      }
      return osInfo;
    }

  },
  isToken() {
    if (baseConfig.enableLocalMode && baseConfig.localConfiguration.token[this.getEnvStr()]) {
      return true;
    }
    if (this.isInWebview()) {
      let userInfo = nativeBridge.getUserInfo();

      return !!(userInfo && userInfo['access_token']);
    }
    return false;
  },
  toNum(a) {
    a.toString();
    //也可以这样写 var c=a.split(/\./);
    let c = a.split('.');

    let numPlace = ['', '0', '00', '000', '0000'];

    let r = numPlace.reverse();

    let codes = ['', '', ''];
    //最多取3位, iOS的本地包版本可能有4位，比如：5.34.0.5
    for (let i = 0; i < c.length && i < 3; i++) {
      let len = c[i].length;

      codes[i] = r[len] + c[i];
    }
    let res = codes.join('');

    return res;
  },
  /**
   *
   * @param {version} 传入要比较的版本号
   *
   */
  cprVersion(version = '') {
    // 版本比较
    let appInfo = nativeBridge.getAppInfo()?.data || {};
    // 传参不能为空/取App版本不能为空
    console.log('app Info', appInfo);
    if (version === '' || !appInfo || !appInfo.version || appInfo.version === '蔚来') {
      return false;
    }
    //当前包的版本
    let currentVersion = this.toNum((appInfo && appInfo.version) || '3.3.5');
    //传入版本
    let compareVersion = this.toNum(version);
    // 比较 当前app版本 大于等于 传入比较版本号
    return parseInt(currentVersion) >= parseInt(compareVersion);
  },
  showVersionUpgradeToast(){
    nativeBridge.showToast("App版本较低，请到“我的-设置-检测更新”升级后继续使用");
  },
  // 关闭当前页面打开新页面
  replacePage(pageName, queryString = '', queryObj = {}) {
    let open_url = `${
      this.getEnvHost()
    }${this.basePath()}/${pageName}?wv=lg&is_nav_show=false${queryString}`;
    if (this.isInWebview() && !baseConfig.localConfiguration.enableLocalMode) {
      console.log('replacePage===>', open_url);
      nativeBridge.replace({
        data: {
          url: open_url,
        },
        callback: data => {
          console.log('replacePage callback==', open_url);
        },
      });
    } else {
      window.location.replace(`/#/${pageName}`);
    }
  },
  // 打开新页面
  openPage(pageName, queryString = '') {
    let open_url = `${
      this.getEnvHost()
    }${this.basePath()}/${pageName}?wv=lg&is_nav_show=false${queryString}`;
    if (this.isInWebview() && !baseConfig.localConfiguration.enableLocalMode) {
      nativeBridge.openURL({
        data: { url: open_url },
        callback: result => {
          console.log('openurl callback==',result);
        },
      });
    } else {
      window.location.href = `${pageName}?${queryString}`;
    }
  },
  // 返回上级，支持多级
  goBack(step = 1, name = '') {
    nativeBridge.back({
      data: {
        step,
        name,
      },
    });
  },
  //深拷贝
  clone(target, map = new WeakMap()) {
    if (typeof target === 'object' && target !== null) {
      let cloneTarget = Array.isArray(target) ? [] : {};

      if (map.has(target)) {
        return map.get(target);
      }
      map.set(target);
      for (const key in target) {
        cloneTarget[key] = this.clone(target[key], map);
      }
      return cloneTarget;
    }
    return target;
  },

  // 数字每三位加逗号
  thousands(num) {
    let str = num.toString();

    let reg = str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;

    return str.replace(reg, '$1,');
  },
  formatterMoney(value) {
    value = parseFloat(value);
    if (value > 10000) {
      value = value / 10000;
      value = `${this.thousands(value)}万元`;
      return value;
    }
    value = `${this.thousands(value)}元`;
    return value;
  },
  //引入CDN静态资源JSON
  fetchDataFromCDN(path, success, error) {
    const script = document.createElement('script');

    script.src = path;
    document.getElementsByTagName('head')[0].appendChild(script);
    script.onload = () => {
      success && success();
    };
    script.onerror = () => {
      error && error();
    };
  },
  /**
   * @param fn 回调
   * @param wait 间隔时间
   * @param immediate  第一次是否立即执行
   * @return function 返回一个闭包函数
   * */
  debounce(fn, wait = 1000, immediate) {
    let timer = null;

    let hasExec = false; //防止重复执行

    return function (...args) {
      if (timer) {
        clearTimeout(timer);
      }
      // immediate 为 true 表示第一次触发后执行
      // timer 为空表示首次触发
      //console.log(immediate, timer)
      if (immediate && !timer) {
        fn.apply(this, args);
        hasExec = true;
      } else {
        hasExec = false;
      }
      timer = setTimeout(() => {
        if (!hasExec) {
          fn.apply(this, args);
        }
        timer = null;
      }, wait);
    };
  },

  initVConsole() {
    const env = this.getEnv();
    // 生产环境外注入vconsole
    if (env !== 3) {
      let head = document.getElementsByTagName('head')[0];
      let consoleScript = document.createElement('script');
      consoleScript.src = baseConfig.vconsoleSrc;
      consoleScript.type = 'text/javascript';
      consoleScript.defer = true;
      head.appendChild(consoleScript);
      consoleScript.onload = function () {
        new VConsole();
      };
    }
  },
  /** 下划线转小驼峰 */
  underlineToCamel(str) {
    return str.replace(/_(\w)/g, (all, letter) => letter.toUpperCase());
  },
  /** 驼峰转下划线 */
  camelToUnderline(str) {
    return str.replace(/([A-Z])/g, '_$1').toLowerCase();
  },
  isTimeInRange(start, end) {
    const now = moment();
    const startTime = moment(start, 'HH:mm');
    const endTime = moment(end, 'HH:mm');

    return now.isBetween(startTime, endTime);
  },
  // 存储本地缓存
  async setAppStorage(key, value, expireTime= null) {
    if (key === undefined || value === undefined) {
      console.error('setAppStorage的key或value不能为空');
      return;
    }
    if (!expireTime) {
      // 获取当前时间
      const currentDate = new Date();
      // 推迟五年后的时间
      const nextYear = new Date(currentDate);
      nextYear.setFullYear(currentDate.getFullYear() + 5);
      // 获取推迟一年后的时间戳（单位秒）
      const timestampInMillSeconds = Math.floor(nextYear.getTime());
      console.log('推迟一年后的时间戳（单位毫秒）:', timestampInMillSeconds);
      expireTime = timestampInMillSeconds;
    }

    await universalStorage.set({
      data: {
        key,
        value,
        expireTime
      },
    });
  },
  // 获取本地缓存
  async getAppStorage(storageKey) {
    let res = null;
    if (storageKey === undefined) {
      console.error('getAppStorage的key不能为空');
      return res;
    }
    const result = await universalStorage.get(
        {
          data: {
            key:storageKey
          }
        }
    );
    console.log("getAppStorage result==", result)

    if (result && result?.data) {
      res = result.data.value || null;
    }
    return res;
  },
  // 删除本地缓存
  async removeAppStorage(key) {
    if (key === undefined) {
      console.error('removeAppStorage的key不能为空');
      return;
    }
    await universalStorage.remove({
      data: {
        key,
      },
    });
  },
  // 清除本地缓存
  async clearAppStorage() {
    await universalStorage.clear();
  },

  // 获取车辆信息
  getVehicleId() {
    return new Promise((resolve) => {
      try {
        nativeBridge.getVehicleInfo({
          callback:(result) => {
            console.log("vehicleInfo==>",result)
            if (result.result_code === "success" && result.data && result.data.length > 0) {
              const vehicle = result.data.find(vehicle=> vehicle.is_activated && vehicle.is_checked)
              console.log("selected vehicle==>",vehicle?.vehicle_id)
              resolve(vehicle?.vehicle_id || '')
            } else {
              resolve('')
            }
          }
        })
      } catch (error) {
        console.log("vehicleInfo error ==>", error)
        resolve('')
      }
    })
  },

  async isMobileCarWashOpen() {
    const env = this.getEnvStr();
    const time = Date.now();
    const url = `https://static.nio.com/fx-static/1766/fixed/is_mobile_carwash_open.${env}.json?t=${time}`;
    const result = await fetch(url);
    if (result.ok) {
      const json = await result.json();
      const isOpen = json.is_mobile_carwash_open === true;
      console.log(url, isOpen);
      return isOpen;
    }

    console.log(url, false);
    return false;
  },

  // 是否支持上门洗车
  async isMobileCarWashSupport() {
    // 当前只有nio且最低5.34.0版本
    const isNativeSupport = isNio() && this.cprVersion("5.34.0");
    return !!(isNativeSupport || isAlps() || isFyCN());
  },

  async getGiftBoxInfo() {
    const time = Date.now();
    const urlNio = `https://static.nio.com/fx-static/1766/fixed/box-banner.all.json?t=${time}`;
    const urlAlps = `https://static.nio.com/fx-static/4705/fixed/box-banner.all.json?t=${time}`;
    const urlFY = 'https://cdn-fx.nio.com/fx/fy-car-wash/__fx_config__/box-banner.all.json.prod.json?t=${time}'
    const url = isNio() ? urlNio : (isAlps() ?urlAlps :urlFY) ;

    const result = await fetch(url);
    if (result.ok) {
      const json = await result.json();
      console.log(url, json);
      return json;
    }

    return {};
  },

};
